<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-18 09:32:49
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 10:47:54
 * @FilePath: /privacy-web/src/components/The/TheMenuItem.vue
-->
<template>
  <div class="menus-item" :class="{ 'menus-item-mobile': isMobile }">
    <div class="name" @click="handleMenu(item)">{{ item.name }}</div>
  </div>
</template>
<script>
export default {
  name: "TheMenuItem",
  props: { item: { type: Object, default: () => {} } },
  methods: {
    handleMenu(item) {
      this.$emit("switch-router", item.path);
    },
  },
};
</script>
<style lang="scss" scoped>
.menus-item {
  width: calc($multiple * 122px);
  height: 100%;
  cursor: pointer;
  position: relative;
  margin: 0 calc($multiple * 25px);
  &:last-child {
    margin-right: 0;
  }
  .name {
    height: 100%;
    display: flex;
    line-height: calc($multiple * 50px);
    justify-content: center;
    font-size: calc($multiple * 16px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
  }
}
.menu-active::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 100%;
  height: calc($multiple * 4px);
  background-color: rgba(1, 115, 246, 1);
  border-radius: 3px;
}
.menu-active .name {
  color: rgba(2, 115, 245, 1);
}
// .menus-item {
//   width: 1.63rem;
//   height: 100%;
//   margin-right: 0.7rem;
//   cursor: pointer;
//   position: relative;
//   .name {
//     height: 100%;
//     display: flex;
//     line-height: 0.93rem;
//     justify-content: center;
//     font-size: 0.2rem;
//     font-family: PingFangSC-Regular, PingFang SC;
//     font-weight: 400;
//     color: rgba(0, 0, 0, 0.84);
//   }
// }
// .menu-active::after {
//   content: '';
//   position: absolute;
//   bottom: 0;
//   width: 100%;
//   height: 0.05rem;
//   background-color: rgba(1, 115, 246, 1);
//   border-radius: 0.03rem;
// }
// .menu-active .name {
//   color: rgba(2, 115, 245, 1);
// }
// .menus-item-mobile {
//   width: 2.5rem;
//   margin-right: 0;
//   .name {
//     line-height: 2.61rem;
//     font-size: 0.5rem;
//     color: #fff;
//     margin: auto;
//   }
// }
</style>
